import React, { Component } from 'react'
import Post from './Post'
import Spinner from '../Spinner'
import './blog.css'

import axios from '../../axios'
import { withErrorHandler } from '../../hocs'

const FullPost = ({ id, text }) => {
  if (id === null) {
    return <div>Select a post...</div>
  }
  if (text === '') {
    return <Spinner />
  }
  return <div>{text}</div>
}

class Blog extends Component {
  state = {
    posts: [],
    selectedPostId: null,
    selectedPostText: '',
    getPostsError: false,
    getPostError: false,
    errorMessage: false,
  }

  componentDidMount() {
    axios
      .get('https://jsonplaceholder.typicode.com/posts')
      .then((response) => {
        const posts = response.data.slice(0, 4)
        const updatedPosts = posts.map((post) => ({ ...post, author: 'Joe' }))
        if (this.state.getPostsError) {
          this.setState({ errorMessage: true })
          this.setState({ getPostsError: false })
        }
        this.setState({ posts: updatedPosts })
      })
      .catch((error) => {
        this.setState({ errorMessage: true })
        this.setState({ getPostsError: true })
      })
  }

  handleClick = (id) => (e) => {
    if (id) {
      this.setState({ selectedPostId: id, selectedPostText: '' })
      axios
        .get(`/posts/${id}`) // https://jsonplaceholder.typicode.com is in baseURL in index.js
        .then((response) => {
          const post = response.data
          if (this.state.getPostError) {
            this.setState({ getPostError: false })
          }
          this.setState({ selectedPostText: post.body })
        })
        .catch((error) => this.setState({ getPostError: true }))
    }
  }
  handleClose = (e) => {
    e.preventDefault()
    this.setState({ errorMessage: false })
  }

  ErrorMessage = () => <>Cannot fetch posts!</>

  render() {
    const posts = this.state.posts.map((post) => (
      <Post
        handleClick={this.handleClick(post.id)}
        name={post.author}
        key={post.id}
        title={post.title}
        text={post.body}
      />
    ))

    return (
      <div className="blog-container">
        {this.state.errorMessage
          ? withErrorHandler(this.ErrorMessage, this.handleClose)
          : null}
        <div className="blog-head">
          <h1>Web Log</h1>
        </div>
        <div className="blog-body">
          {this.state.getPostsError ? <h3>No posts available</h3> : posts}
        </div>
        <div className="blog-footer">
          {this.state.getPostError ? (
            <h3>Cannot fetch post!</h3>
          ) : (
            <FullPost
              id={this.state.selectedPostId}
              text={this.state.selectedPostText}
            />
          )}
        </div>
      </div>
    )
  }
}

export default Blog
